import styles from './budgetLoadingSkeleton.module.scss';

const BudgetLoadingSkeleton = () => {
  return (
    <div
      className={styles.container}
      data-testid='budget-loading-skeleton'
      aria-busy='true'
      aria-label='Loading project budget'
    >
      <div className={styles.header}>
        <span className={styles.heading} />
        <span className={styles.noTaxes} />
      </div>

      {Array.from({ length: 3 }, (_, sectionIndex) => (
        <section
          className={styles.section}
          data-testid='budget-section-skeleton'
          aria-label={`Loading budget section ${sectionIndex + 1}`}
          key={`budget-section-${sectionIndex}`}
        >
          <span className={styles.sectionHeading} />
          <div className={styles.cards}>
            {Array.from({ length: 4 }, (_, cardIndex) => (
              <div
                className={styles.card}
                data-testid='budget-card-skeleton'
                key={`budget-card-${sectionIndex}-${cardIndex}`}
              >
                <span className={styles.cardLabel} />
                <span className={styles.cardValue} />
                {cardIndex === 1 || cardIndex === 2 ? <span className={styles.cardSecondaryValue} /> : null}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default BudgetLoadingSkeleton;
